export const calculateSIP = (monthlyAmount, years, annualRate) => {
    const totalMonths = years * 12;
    const monthlyRate = Math.pow(1 + (annualRate / 100), 1 / 12) - 1;

    const monthlyData = Array.from({ length: totalMonths }, (_, monthIndex) => {
        const month = monthIndex + 1;
        const year = Math.floor(monthIndex / 12) + 1;
        let totalInvestment = 0;
        let previousTotalValue = 0;

        for (let i = 0; i <= monthIndex; i++) {
            totalInvestment += monthlyAmount;
            previousTotalValue += monthlyAmount;
            previousTotalValue *= (1 + monthlyRate);
        }

        const gain = Math.round(previousTotalValue) - Math.round(totalInvestment);

        return {
            month,
            year,
            Investment: Math.round(totalInvestment),
            Gain: gain,
            totalValue: Math.round(previousTotalValue)
        };
    });

    const yearlyData = Array.from({ length: years }, (_, yearIndex) => {
        const year = yearIndex + 1;
        const yearStartMonth = yearIndex * 12;
        const yearEndMonth = (yearIndex + 1) * 12 - 1;
        const yearData = monthlyData.slice(yearStartMonth, yearEndMonth + 1);
        const lastMonthData = yearData[yearData.length - 1];

        return {
            year,
            Investment: lastMonthData.Investment,
            Gain: lastMonthData.Gain,
            totalValue: lastMonthData.totalValue
        };
    });

    const finalData = yearlyData[yearlyData.length - 1];

    return {
        totalInvestment: finalData.Investment,
        totalValue: finalData.totalValue,
        totalGain: finalData.Gain,
        yearlyData
    };
};

export const calculateLumpsum = (amount, years, annualRate) => {
    const futureValue = amount * Math.pow(1 + annualRate / 100, years);
    const yearlyData = [];

    for (let year = 1; year <= years; year++) {
        const currentValue = amount * Math.pow(1 + annualRate / 100, year);
        yearlyData.push({
            year: year,
            Investment: amount,
            Gain: Math.round(currentValue - amount),
            totalValue: Math.round(currentValue)
        });
    }

    return {
        totalInvestment: amount,
        totalValue: Math.round(futureValue),
        totalGain: Math.round(futureValue - amount),
        yearlyData: yearlyData
    };
};

export const formatCurrency = (value) => {
    return `₹${value.toLocaleString('en-IN')}`;
};

export const investmentSteps = [
    100, 500, 1000, 1500, 2000, 3000, 5000, 10000, 15000, 20000, 25000,
    30000, 40000, 50000, 75000, 100000, 125000, 150000, 175000, 200000,
    225000, 250000, 275000, 300000, 325000, 350000, 375000, 400000, 425000,
    450000, 475000, 500000, 525000, 550000, 575000, 600000, 625000, 650000,
    675000, 700000, 725000, 750000, 775000, 800000, 825000, 850000, 875000,
    900000, 925000, 950000, 975000, 1000000
];

export const findClosestStepValue = (value) => {
    return investmentSteps.reduce((prev, curr) =>
        Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev
    );
};